<template>
  <div class="illustList">
    <IllustListItem
      v-for="(illustData, index) in illustDatas" 
      v-bind:illustData="illustData" 
      v-bind:key="index"></IllustListItem>
  </div>
</template>

<script>
import IllustListItem from './IllustListItem'

var _illustDatas = require('../../../assets/data/IllustDatas.json');
export default {
  name: 'IllustListControll',
  components: {
    IllustListItem
  },
  data(){
    return{
      illustDatas: _illustDatas
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
/*スマートフォン版レイアウト*/
.illustList{
  width: calc(100vw - 20px);
  height: 100%;
  margin: 0 10px;
  display: flex;
  flex-wrap: wrap;
  justify-content:space-evenly;
  position: absolute;
  top:0;
  left:0;
  overflow-y: auto;
}



/*タブレット版レイアウト*/

/*PC版レイアウト*/
@media screen and (min-width: 1280px){
  .illustList{
    width: calc(100vw - 20px);
    height: calc(100vh - 110px);
    margin: 10px;
    padding-top: 15px;
    padding-bottom: 15px;
    display: flex;
    flex-wrap: wrap;
    justify-content:space-evenly;
    position: absolute;
    top:0;
    left:0;
    overflow-y: auto;
  }
}
</style>
